import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { TimeService } from 'src/app/services/time/time.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-assign-message',
  templateUrl: './assign-message.component.html',
  styleUrls: ['./assign-message.component.css']
})
export class AssignMessageComponent implements OnInit {

  //recieved data
  messages: Array<any>;
  messageTypes: Array<string>;
  groups: Array<any>
  lobList: Array<string>;

  //filtered/displayed data
  filteredGroups: Array<any> = [];
  filteredMessages: Array<any> = [];
  groupMessages: Array<any> = [];
  
  //selectors
  lobSelect: string = "DEFAULT";
  groupSelect: string = "DEFAULT";
  messageTypeSelect: string;

  //other pagevariables
  defaultLang: string = 'en-US'
  showGroupTable: boolean = false;
  showMessageTable: boolean = false;
  lambdaMessage: string = '';
  lambdaError: boolean = false;
  formValid: boolean = false;
  currentUser: string = this.auth.currentUser;
  isTelecom: boolean;

  //use config to get the active LOB
  constructor(private telecomService: TelecomService, private timeService: TimeService, private auth: AuthService, private config: ConfigService) { }

  ngOnInit() {
    this.isTelecom = this.auth.memberOf.includes(environment.roles.telecom);
    if(!this.isTelecom){
      this.lobSelect = this.config.activeLOB;
    }
    this.getData();
  }

  getData(){
    this.lambdaMessage = '';
    //messages
    this.telecomService.getRows(environment.messagesLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.messages = response.body.message;
        if(this.messages.length == 0){
          this.lambdaError = false;
          this.lambdaMessage += 'No data to display'
        }
      }else{
        this.lambdaError = true;
        this.lambdaMessage += response.Error.message;
        console.error(response); 
      }
      this.filterMessages();
    });
    //messageTypes
    this.telecomService.getRows(environment.getMessageTypesLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.messageTypes = response.body.messageTypes.Item.data;
      }else{
        this.lambdaError = true;
        this.lambdaMessage += response.Error.message
        console.error(response); 
      }
    });
    //lobs
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobList = resultData.lobList;
    });
    //groups
    this.telecomService.getRows(environment.GroupsLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.groups = response.body.Group.Item.data;
        this.filteredGroups = this.groups;
        if(this.lobSelect != "DEFAULT"){
          this.filterGroups(this.lobSelect);
        }
      }
      else{
        this.lambdaError = true;
        this.lambdaMessage = response.Error.message;
      }
    });
  }

  getGroupMessages(id: string){
    this.showGroupTable = true;
    this.lambdaMessage = '';
    if(id != null && id !="DEFAULT"){
      let params = {
        FunctionName: environment.groupMessagesLambdaName,
        Payload: JSON.stringify({
          operation: 'get',
          groupId: id 
        })
      };
      this.telecomService.callLambda(params, 'An error occurred while trying to retrieve data: ').then((response: any) => {
        if(response.statusCode == 200){
          this.groupMessages = response.body.groupMessages;
          if(this.groupMessages.length == 0){
            this.lambdaError = false;
            this.lambdaMessage = 'No data to display'
          }
          this.filterMessages();
        }else{
          this.lambdaError = true;
          this.lambdaMessage += response.Error.message;
          console.error(response); 
        }
      });
      this.showGroupTable = true;
    }
  }

  updateGroupMessages(evt: any){
    var payload = {}
    evt.item.updatedBy = this.currentUser;
    if(evt.action == 'delete'){
      payload = {
        operation: 'delete',
        data: {
          groupId: this.groupSelect,
          messageId: evt.item.messageId,
        }
      };
    }else if(evt.action == 'put'){
      payload = {
        operation: 'put',
        data: {
          groupId: this.groupSelect,
          messageId: evt.item.messageId,
          messageDuration: evt.item.messageDuration,
          updatedBy: evt.item.updatedBy
        }
      };
    }
    console.log(payload);
    let params = {
      FunctionName: environment.groupMessagesLambdaName,
      Payload: JSON.stringify(payload)
    }
    this.telecomService.callLambda(params, 'Failed to update group message data: ').then((response: any) => {
      if(response.statusCode == 200){
        this.lambdaError = false;
        this.lambdaMessage = 'Data was updated successfully'
        if(evt.action == 'put'){
          let temp = JSON.parse(JSON.stringify(this.groupMessages));
          let index = temp.findIndex(groupMessage => groupMessage.messageId == response.body.groupMessages.messageId);
          if(index == -1){
            temp.push(response.body.groupMessages);
          }else{
            temp[index].lastUpdated = response.body.groupMessages.lastUpdated;
          }
          this.groupMessages = temp;
        }
      }else{
        console.error(response); 
        this.lambdaError = true;
        this.lambdaMessage = response.Error.message;
      }
    });
  }

  addMessageToGroup(evt: any){
    console.log(evt);
    var addItem = JSON.parse(JSON.stringify(evt.item));
    var temp = JSON.parse(JSON.stringify(this.groupMessages));
    delete addItem['lastUpdated'];
    console.log(addItem);
    //update local
    temp.push(addItem);
    this.groupMessages = temp;
    //update back end
    this.updateGroupMessages({action: 'put', item: addItem});
    this.filterMessages();
    this.showMessageTable = false;
  }

  // getMessageText(item){
  //   return item.message.msgText[this.defaultLang];
  // }

  handleButtonEvent(evt: any){
    console.log(evt);
    if(evt.button == 'create'){
      this.showMessageTable = !this.showMessageTable;
    }else if(evt.button == 'delete'){
      this.updateGroupMessages({action: "delete", item: JSON.parse(JSON.stringify(evt.item))});
    }else if(evt.button == 'confirm'){
      this.updateGroupMessages({action: "put", item: JSON.parse(JSON.stringify(evt.item))});
    }
  }

  filterGroups(lob: string){
    if(lob == 'DEFAULT' || lob == 'NoFilter' || lob == null){
      this.filteredGroups = this.groups;
    }else{
      this.filteredGroups = [];
      for(var x = 0; x < this.groups.length; x++){
        if(this.groups[x].LOB == lob){
          this.filteredGroups.push(this.groups[x]);
        }
      } 
    }
  }

  filterMessages(){
    var temp = [];
    for(var y=0; y < this.messages.length; y++){
      var found = false;
      for(var x=0; x<this.groupMessages.length; x++){
        if(this.messages[y].messageId == this.groupMessages[x].messageId){
          found = true;
          break;
        }
      }
      if(!found && ('status' in this.messages[y].message)){
        var status: string = this.messages[y].message.status.toLowerCase();
        if(status == 'enabled'){
          temp.push(this.messages[y]);
        }
      }
    }
    //message type
    if(this.messageTypeSelect != null && this.messageTypeSelect != 'DEFAULT' && this.messageTypeSelect != 'NoFilter'){
      for(var x=0; x < temp.length; x++){
        if(temp[x].message.messageType != this.messageTypeSelect){
          temp.splice(x, 1);
          x--;
        }
      }
    }
    this.filteredMessages = temp;
  }

  validate(item: any){
    this.formValid = false;
    this.lambdaMessage = '';

    if(item.messageDuration.messageStartDate == ''){
      this.lambdaMessage = 'Invalid start date';
      this.lambdaError = true;
      return;
    }

    if(item.messageDuration.messageEndDate == ''){
      this.lambdaMessage = 'Invalid end date';
      this.lambdaError = true;
      return;
    }

    var start = new Date(item.messageDuration.messageStartDate);
    start.setHours(this.timeService.getHoursFromString(item.messageDuration.messageStartTime), this.timeService.getMinutesFromString(item.messageDuration.messageStartTime));
    var end = new Date(item.messageDuration.messageEndDate);
    end.setHours(this.timeService.getHoursFromString(item.messageDuration.messageEndTime), this.timeService.getMinutesFromString(item.messageDuration.messageEndTime));

    if(start > end){
      this.lambdaMessage = 'End date/time must be after start date/time';
      this.lambdaError = true;
      return;
    }

    const min = new Date(new Date().getFullYear(), 0, 1, 0, 0, 0);
    const max = new Date(new Date().getFullYear(), 11, 31, 23, 59, 59);
    if((min > start) || (start > max)){
      this.lambdaMessage = 'Starting time must be in the current year';
      this.lambdaError = true;
      return;
    }

    this.formValid = true;
  }

  getMessageText(item){
    return "HEEEEYYY!"
  }

}
